import FollowingList from ".";

export const followingUserRoutes = (data) => {
  return [
    {
      path: "/:lang/following",
      title: "Following",
      layout: "front",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: FollowingList,
    },
  ];
};
